import React, { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { RadioField } from 'Shared/form/RadioField';
import { camelCase } from 'lodash';
import { DatePickerField } from 'Shared/form/DatePickerField';
import { dateRangeOptions } from '../../workQueue.constant';
import { setWorkQueueFilterGenerator } from '../../workQueue.utils';
import AccordionWrapper from 'App/components/AccordionWrapper/AccordionWrapper';
import HeaderContent from '../HeaderContent';

const DateRangeSelectFilter = () => {
    const { values, setFieldValue } = useFormikContext();
    const {
        result: { activityCountResult },
        filterParams,
    } = values;
    const setWorkQueueFilter = setWorkQueueFilterGenerator(setFieldValue);

    const options = useMemo(() => {
        return dateRangeOptions.map((range) => {
            const activityCount = activityCountResult[camelCase(range.value)];
            return {
                id: range.value,
                option: `${range.name} ${activityCount >= 0 ? `(${activityCount})` : ''}`,
            };
        });
    }, [activityCountResult]);

    return (
        <AccordionWrapper
            title="Date Range"
            stateKey="workQueueDateRange-toggle"
            HeaderContent={HeaderContent}
            headerClassName="accordion-header-h4-title"
        >
            <div className="date-range-select-filter">
                <RadioField
                    fieldName="filterParams.type"
                    options={options}
                    onChange={(e) => setWorkQueueFilter(filterParams, 'type', e.target.value, true)}
                />
                {values.filterParams.type === 'custom' && (
                    <>
                        <DatePickerField
                            fieldName="filterParams.dateStart"
                            label="Date Range Start"
                            onChange={(date) => setWorkQueueFilter(filterParams, 'dateStart', date, true)}
                            maxDate={filterParams.dateEnd}
                        />
                        <DatePickerField
                            fieldName="filterParams.dateEnd"
                            label="Date Range End"
                            onChange={(date) => setWorkQueueFilter(filterParams, 'dateEnd', date, true)}
                            minDate={filterParams.dateStart}
                        />
                    </>
                )}
            </div>
        </AccordionWrapper>
    );
};

export default DateRangeSelectFilter;
